// Verixa · registrazione Service Worker (PWA offline-ready).
// Tre comportamenti:
//  - in dev (localhost) NON registra (per non interferire con hot reload)
//  - registra solo se HTTPS o localhost
//  - notifica al cambio versione → chiama skipWaiting + reload
import { toast } from "sonner";

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return; // solo in build

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Aggiornamento disponibile?
        reg.addEventListener("updatefound", () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener("statechange", () => {
            if (newSW.state === "installed" && navigator.serviceWorker.controller) {
              // È pronta una nuova versione: avvisa l'utente
              try {
                toast.info("Nuova versione disponibile", {
                  description: "Aggiorna per usare l'ultima versione",
                  action: {
                    label: "Aggiorna",
                    onClick: () => {
                      newSW.postMessage("SKIP_WAITING");
                      setTimeout(() => window.location.reload(), 200);
                    },
                  },
                  duration: 12000,
                });
              } catch {
                // Fallback se sonner non è ancora pronto
                console.info("Verixa: nuova versione pronta. Ricarica la pagina.");
              }
            }
          });
        });
      })
      .catch((err) => {
        console.warn("Service Worker registration failed:", err);
      });

    // Reload automatico quando il SW prende il controllo (post skipWaiting)
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
